// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b8fc0f28","896":"1e9cd801"}[chunkId] + ".chunk.js";
};